import { c as _c } from "react/compiler-runtime";
import { Box, Button, Heading, HStack, Text } from '@chakra-ui/react';
import { ButtonStack } from '@src/components/sco/ButtonStack';
import { PhoneIcon } from '@src/components/sco/icons';
import { useQueryState } from 'nuqs';
import React from 'react';
export type PricingNotSureCalloutProps = {
  /** `inline` is one line for inside another offer (the pricing closing offer); `block` stands alone. */
  variant?: 'block' | 'inline';
};
export const PricingNotSureCallout: React.FC<PricingNotSureCalloutProps> = t0 => {
  const $ = _c(15);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "block" : t1;
  const [, setPrompt] = useQueryState("prompt");
  if (variant === "inline") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        base: "center",
        md: "start"
      };
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Text color="fg.muted" textStyle="sm">Not sure which plan fits?</Text>;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        textDecorationColor: "currentColor"
      };
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    let t5;
    if ($[3] !== setPrompt) {
      t5 = () => setPrompt("consultation");
      $[3] = setPrompt;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <PhoneIcon />;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== t5) {
      t7 = <HStack columnGap={1.5} justify={t2} rowGap={0} wrap="wrap">{t3}<Button _hover={t4} gap={1.5} h="auto" minW={0} px={0} py={0.5} size="sm" textDecoration="underline" textDecorationColor="border.emphasized" textUnderlineOffset="3px" variant="plain" onClick={t5}>{t6}Book a call with us</Button></HStack>;
      $[6] = t5;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    return t7;
  }
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading as="h3">Still not sure?</Heading>;
    t3 = <br />;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[10] !== setPrompt) {
    t4 = () => setPrompt("consultation");
    $[10] = setPrompt;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PhoneIcon />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4) {
    t6 = <Box><Box maxW="2xl" mx="auto" textAlign="center">{t2}{t3}<ButtonStack><Button onClick={t4}>{t5}Book a Call with Us</Button></ButtonStack></Box></Box>;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};